var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-positive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    d: "M0-682.665H42v42H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69034",
    "data-name": "Group 69034",
    transform: "translate(1716 -4178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17107",
    "data-name": "Rectangle 17107",
    width: 48,
    height: 48,
    transform: "translate(-1716 4178)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2001",
    transform: "translate(-1713 4181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2005",
    clipPath: "url(#clip-path-positive)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2011",
    transform: "translate(1.641 1.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    d: "M-295.307-590.613a19.359,19.359,0,0,1-19.359-19.359,19.359,19.359,0,0,1,19.359-19.359,19.359,19.359,0,0,1,19.359,19.359A19.359,19.359,0,0,1-295.307-590.613Z",
    transform: "translate(314.666 629.332)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2015",
    transform: "translate(14.109 26.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    d: "M0,0S2.506,3.938,6.891,3.938,13.781,0,13.781,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2019",
    transform: "translate(11.73 13.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    d: "M-218.977-31.282a2.051,2.051,0,0,0,2.051,2.051,2.051,2.051,0,0,0,2.051-2.051,2.051,2.051,0,0,0-2.051-2.051,2.051,2.051,0,0,0-2.051,2.051m-12.3-2.051a2.051,2.051,0,0,1,2.051,2.051,2.051,2.051,0,0,1-2.051,2.051,2.051,2.051,0,0,1-2.051-2.051,2.051,2.051,0,0,1,2.051-2.051",
    transform: "translate(233.333 33.333)",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.eae02700ecb93f63b86fe4d0a82f6007.svg";
export { ForwardRef as ReactComponent };